const DIACRITIC_REGEX = /[\u0300-\u036f]/g;
const NON_SLUG_CHARS = /[^a-z0-9]+/g;

function baseSlugify(value: string): string {
  if (!value) return "";

  const normalized = value
    .normalize("NFKD")
    .replace(DIACRITIC_REGEX, "")
    .toLowerCase();

  const collapsed = normalized
    .replace(NON_SLUG_CHARS, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");

  return collapsed || normalized.replace(/\s+/g, "-").replace(/-+/g, "-");
}

export function createSlugFromPartNumber(partNumber: string): string {
  return baseSlugify(partNumber);
}

export function normalizeSlugInput(value: string): string {
  return baseSlugify(value);
}
